import { Stack, Text } from '@mantine/core'
import { createStyles } from '@mantine/emotion'
import {
  IconBabyCarriage,
  IconCreditCard,
  IconEdit,
  IconMeat,
  IconMoodKid,
  IconQuote,
  IconReportMoney,
} from '@tabler/icons-react'
import { ShortcutCard, ShortcutCardGrid } from 'components/ShortcutCard'
import { useMemo } from 'react'
import { PERMISSIONS } from 'util/permissions'
import { FeedbackCard } from './Feedback'

const shortcuts = [
  {
    title: 'Nytt innskudd',
    icon: IconCreditCard,
    color: 'samfundet-red',
    link: '/economy/deposits/create',
  },
  {
    title: 'Legg til sitat',
    icon: IconQuote,
    color: 'samfundet-red',
    link: '/quotes/create',
  },
  {
    title: 'Alle vakter',
    icon: IconBabyCarriage,
    color: 'samfundet-red',
    link: '/schedules/all-shifts',
  },
  {
    title: 'Nytt referat',
    icon: IconEdit,
    color: 'samfundet-red',
    link: '/summaries/create',
    permissions: [PERMISSIONS.summaries.add.summary],
  },
]

interface ShortcutCardsProps {
  sociOrderSession: boolean
  showNewbies: boolean
  showStockMarketShortcut: boolean
  showFeedback: boolean
}

export const ShortcutCards: React.FC<ShortcutCardsProps> = ({
  sociOrderSession,
  showNewbies,
  showStockMarketShortcut,
  showFeedback,
}) => {
  const { classes } = useStyles()

  const memoizedShortcuts = useMemo(() => {
    if (showNewbies) {
      return [
        ...shortcuts,
        {
          title: 'De nye',
          icon: IconMoodKid,
          color: 'samfundet-red',
          link: '/users/newbies',
        },
      ]
    } else {
      return shortcuts
    }
  }, [showNewbies])

  return (
    <Stack>
      <Text className={classes.title}>Snarveier</Text>

      {showStockMarketShortcut && (
        <ShortcutCard
          title="Børsen er åpen"
          icon={IconReportMoney}
          color="green"
          link="/economy/socinomics"
        />
      )}

      {sociOrderSession && (
        <ShortcutCard
          title="Stilletime"
          icon={IconMeat}
          color="samfundet-red"
          link="/economy/soci-sessions/live"
        />
      )}

      <ShortcutCardGrid shortcuts={memoizedShortcuts}>
        {showFeedback && <FeedbackCard />}
      </ShortcutCardGrid>
    </Stack>
  )
}

const useStyles = createStyles({
  title: {
    fontFamily: `Greycliff CF, var(--mantine-font-family)`,
    fontWeight: 700,
  },
})
